import { observer } from 'mobx-react-lite'
import { type FC } from 'react'
import { Box, Button, SpinnerLoader, Tooltip, Typography } from 'shared/ui'
import { useEntitiesContext } from 'entities/EntitiesExport'
import { type Integration } from 'entities/Integrations'
import { useIntegrationStoreMemo } from 'pages/settings/pages/integrations/pages/integrationSettings/hooks/useIntegrationStoreMemo'
import { IntegrationSlackSettingsStore } from 'pages/settings/pages/integrations/pages/integrationSettings/IntegrationSlackSettings/store/IntegrationSlackSettingsStore'
import { MappingRow } from 'pages/settings/pages/integrations/pages/integrationSettings/IntegrationSlackSettings/ui/MappingRow/MappingRow'
import styles from './styles.module.scss'

type IIntegrationSlackSettings = {
  integration: Integration
}

export const IntegrationSlackSettings: FC<IIntegrationSlackSettings> = observer(
  ({ integration }) => {
    const entities = useEntitiesContext()
    const store = useIntegrationStoreMemo(IntegrationSlackSettingsStore, integration, entities)
    const { mappings, canAddMapping, tooltipMessage, addMapping, isEmptyMappings } = store

    if (store.loading) {
      return <SpinnerLoader ariaLabel={'IntegrationSlackSettings'} />
    }

    return (
      <div className={styles.container}>
        <Typography variant={'body-lg-medium'} ariaLabel={'mapInboxesToSlackChannels'}>
          Map inboxes to slack channels
        </Typography>
        {mappings.map((mapping) => (
          <MappingRow key={mapping.id} store={store} mapping={mapping} />
        ))}
        <Box marginTop={3}>
          <Tooltip label={canAddMapping ? '' : tooltipMessage} placement='top'>
            <Button
              text='Add inbox'
              contained='secondary'
              size='medium'
              iconProps={{ icon: 'add' }}
              onClick={addMapping}
              disabled={!canAddMapping || isEmptyMappings}
            />
          </Tooltip>
        </Box>
      </div>
    )
  }
)
